import React from 'react';
import moment from 'moment';
import { sitePhpVersions, siteWordPressVersions } from '../services/constant';

const SiteInfoModal = ({ deployData }) => {
  return (
    <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">Site Details</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            {deployData ? (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <tbody>
                    <tr><th>Name</th><td>{deployData.name || '-'}</td></tr>
                    <tr><th>Link</th><td>
                      {deployData.link ? (
                        <a href={deployData.link} target="_blank" rel="noreferrer">{deployData.link}</a>
                      ) : '-'}
                    </td></tr>
                    <tr><th>Running Status</th><td>{deployData.runningStatus ? 'SUCCESS' : 'ERROR'}</td></tr>
                    <tr><th>Status</th><td>{deployData.status ? 'Active' : 'Inactive'}</td></tr>
                    <tr><th>SSL Expiry</th><td>{deployData.sslExpiry && deployData.sslExpiry !== 'NO_CERT_INFO' ? moment(deployData.sslExpiry).format('DD/MM/YYYY') : '-'}</td></tr>
                    <tr><th>Domain Expiry</th><td>{deployData.domainExpiry ? moment(deployData.domainExpiry).format('DD/MM/YYYY') : '-'}</td></tr>
                    <tr><th>PHP Version</th><td>{sitePhpVersions.find(v => v.value === String(deployData.phpVersion))?.name || '-'}</td></tr>
                    <tr><th>WordPress Version</th><td>{siteWordPressVersions.find(v => v.value === String(deployData.wordPressVersion))?.name || '-'}</td></tr>
                    <tr><th>Contact</th><td>{deployData.contact || '-'}</td></tr>
                    <tr><th>Comment</th><td>{deployData.comment || '-'}</td></tr>
                    <tr><th>Last Updated</th><td>{deployData.lastUpdated ? moment(deployData.lastUpdated).format('DD/MM/YYYY HH:mm') : '-'}</td></tr>
                  </tbody>
                </table>
              </div>
            ) : (
              <p>No data available</p>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteInfoModal;
